import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
import VueScrollTo from 'vue-scrollto'

import '@/components/input/GlobalsImport.js'
import '@/components/globals/GlobalsImport.js'
import Footer from '@/components/design/Footer.vue'

import '@/javascript/plugins/constants.js'
import '@/javascript/plugins/globals.js'
import '@/javascript/plugins/auth.js'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(VueScrollTo, {
     duration: 500,
 })

Vue.component('custom-footer', Footer)

const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    'de': require('./lang/de.json')
  }
})

let eventBus = new Vue();
Vue.$eventBus = eventBus;
Vue.prototype.$eventBus = eventBus;

window.vue = new Vue({
	  el: '#app',
	  i18n,
	  router,
	  components: {
	    App
	  },
	  render: function(createElement) {
        return createElement(
            App
        )
	  }
	  //template: '<App/>',
	})



// WEBPACK FOOTER //
// ./src/main.js